

const DataCaptureListPickerDirective = function () {

  return {
    restrict: 'E',
    controller: 'DataCaptureListPickerController',
    controllerAs: 'vm',
    link: function () {},
    scope: {
      datacaptures: '=',
      currentDatacapture: '='
    },
    bindToController: true,
    templateUrl: 'dash/topControls/dataCaptureSelector/dataCaptureListPicker/dataCaptureListPicker.tpl.html'
  };
};

DataCaptureListPickerDirective.$inject = [];
module.exports = DataCaptureListPickerDirective;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/dataCaptureListPicker/DataCaptureListPickerDirective.js